import {computed, Directive, inject, input, Signal} from '@angular/core';
import {TaAppStore} from '../../../state/clcta-store';
import {TaTemplateDetails, TravellerDetails} from '../../../api';
import {TemplateDatasource} from '../../../datasources/template.datasource';
import {TaSearchDatasource} from '../../../datasources/ta-search-datasource';

/** Template counterpart of CreateTaBaseComponent: reads the template from TemplateDatasource. */
@Directive()
export abstract class CreateTemplateBaseComponent {
  isReadOnly = input<boolean>(false);
  store = inject(TaAppStore);
  templateDatasource = inject(TemplateDatasource);
  taSearchDatasource = inject(TaSearchDatasource);

  readonly template: Signal<TaTemplateDetails | undefined> = this.templateDatasource.template;

  // Primary first, then by surname.
  sortedTravellers = computed<TravellerDetails[]>(() => {
    const primaryUserId = this.template()?.primaryTraveller?.id;
    return [...(this.template()?.travellers ?? [])].sort((t1, t2) => {
      if (!!primaryUserId && t1.details?.id === primaryUserId) return -1;
      if (!!primaryUserId && t2.details?.id === primaryUserId) return 1;
      if (!t1.details?.surname && !t2.details?.surname) return 0;
      if (!t1.details?.surname) return 1;
      if (!t2.details?.surname) return -1;
      return t1.details.surname.localeCompare(t2.details.surname);
    });
  });
}
